var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ContentOrLoading',[_c('SvgComponent',{attrs:{"zonas":_vm.zonas,"zona_id":_vm.zona_id,"place":_vm.place,"sesion_id":_vm.sesion_id},on:{"clickZona":_vm.irAZona}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }